// extracted by mini-css-extract-plugin
export var productImage = "_qj-1";
export var viewLink = "_qj-2";
export var wishlistItem = "_qj-0";